// extracted by mini-css-extract-plugin
export default {"impersonation":"ImpersonationHeader-impersonation"};